/**
 * Font Size Widget
 * Compact S/M/L toggle for controlling font size in Transcript, Notes, and Summary
 * Uses Meridian ButtonGroup component
 */

import React from 'react';
import ButtonGroup, { ButtonOption } from '@amzn/meridian/button-group';
import { useFontSize, FontSizeOption } from './FontSizeContext';
import { FONT_SIZE_SMALL, TEXT_COLOR_PRIMARY } from '../cssConstants';

const FontSizeWidget: React.FC = () => {
  const { fontSizeOption, setFontSizeOption } = useFontSize();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <span style={{ fontSize: FONT_SIZE_SMALL, color: TEXT_COLOR_PRIMARY }}>Font:</span>
      <ButtonGroup
        value={fontSizeOption}
        onChange={(value) => setFontSizeOption(value as FontSizeOption)}
        size="small"
        type="outline"
      >
        <ButtonOption value="small">S</ButtonOption>
        <ButtonOption value="medium">M</ButtonOption>
        <ButtonOption value="large">L</ButtonOption>
      </ButtonGroup>
    </div>
  );
};

export default FontSizeWidget;
